import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterCoachingPage() {
  return <ClusterPageTemplate clusterName="Coaching" sectorName="Coaches & Consultants" sectorSlug="coaches-consultants" heroTitle="Website laten maken voor een coach" heroDescription="Een persoonlijke, professionele website voor jouw coachingspraktijk. Wij bouwen websites die jouw expertise uitstralen en zorgen voor een volle agenda." websiteOnderdelen={[{
    icon: 'UsersIcon',
    title: 'Over jou',
    description: "Jij bent je merk. Een sterke 'Over mij' pagina met jouw verhaal, visie en achtergrond is cruciaal voor coaches."
  }, {
    icon: 'HeartPulseIcon',
    title: 'Trajecten & Aanbod',
    description: "Heldere uitleg van jouw 1-op-1 trajecten, groepscoaching, online programma's of retreats."
  }, {
    icon: 'StarIcon',
    title: 'Ervaringen',
    description: 'Social proof is essentieel. Toon uitgebreide testimonials en transformatieverhalen van oud-cliënten.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Gratis kennismaking',
    description: 'Een laagdrempelige landingspagina om direct een (online) kennismakingsgesprek in te plannen.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Afspraakplanner',
    description: 'Directe koppeling met Calendly, Acuity of een eigen systeem zodat cliënten zelf een moment kunnen prikken.'
  }, {
    icon: 'FileTextIcon',
    title: 'Lead magnet',
    description: 'Een pop-up of formulier om e-mailadressen te verzamelen in ruil voor een gratis e-book, checklist of video.'
  }, {
    icon: 'BookOpenIcon',
    title: 'Blog & Podcast',
    description: 'Een overzichtelijk platform om je content te delen, wat je autoriteit vergroot en je SEO verbetert.'
  }]} siblingClusters={[{
    name: 'Consultant',
    slug: 'consultant'
  }, {
    name: 'Sportschool',
    slug: 'sportschool'
  }, {
    name: 'Personal Trainer',
    slug: 'personal-trainer'
  }]} faqs={[{
    q: 'Kan ik een online cursus verkopen via mijn website?',
    a: 'Ja, we kunnen je website uitbreiden met een e-learning module (zoals LearnDash) of koppelen aan externe platforms zoals Huddle of Plug&Pay.'
  }, {
    q: 'Hoe krijg ik meer aanmeldingen voor kennismakingsgesprekken?',
    a: 'We optimaliseren de website voor conversie met duidelijke call-to-actions, sterke reviews en een naadloze integratie van een afspraakplanner.'
  }, {
    q: 'Wat kost een website voor een coach?',
    a: 'Een professionele coach-website start vanaf €1.500. Wil je ook online cursussen verkopen of een uitgebreide ledensite, dan maken we een offerte op maat.'
  }, {
    q: 'Kan ik zelf makkelijk blogs toevoegen?',
    a: 'Absoluut. WordPress is van origine een blogsysteem en is perfect geschikt voor het regelmatig publiceren van nieuwe artikelen en content.'
  }]} data-id="element-1067" data-mp="1aivaaewji6gv" />;
}